import React, { memo } from 'react';
import { IFormField, NonDataTypes } from '../schema/interface';

import Description from './NonInputFields/Description';
import Title from './NonInputFields/Title';

interface INonDataFieldController {
    field: IFormField;
}
const NonDataFieldController: React.FC<{ field: IFormField }> = ({
    field
}: INonDataFieldController) => {
    switch (field?.presentation?.displayType) {
        case NonDataTypes.title:
            return <Title field={field} />;
        case NonDataTypes.description:
            return <Description field={field} />;
        default:
            return null;
    }
};

export default memo(NonDataFieldController);
